<template>
  <SelectList
    v-model="selectedValue"
    :clearable="clearable"
    :dense="dense"
    emit-value
    :filled="filled"
    :filter-method="filter"
    :input-debounce="300"
    :label="label"
    :multiple="multiple"
    :no-options-message="noOptionsMessage"
    :option-label="optionLabel"
    option-value="id"
    :options="options"
    :stack-label="stackLabel"
    :use-chips="useChips"
  />
</template>

<script>
import { Organisation } from "shared/resources";

import SelectList from "src/components/common/SelectList.vue";

export default {
  name: "OrganisationsDropdown",
  components: {
    SelectList,
  },
  props: {
    modelValue: {
      type: [Array, Number, String],
      default: null,
    },
    label: {
      type: String,
      default: "Organisations",
    },
    defaultValue: {
      type: [Object, Array],
      default: () => ({}),
    },
    clearable: {
      type: Boolean,
    },
    multiple: {
      type: Boolean,
    },
    useChips: {
      type: Boolean,
    },
    filled: {
      type: Boolean,
    },
    dense: {
      type: Boolean,
    },
    stackLabel: {
      type: Boolean,
    },
    optionLabel: {
      type: String,
      default: "name",
    },
    markInactive: {
      type: Boolean,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      options: [],
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    noOptionsMessage() {
      return "Start typing to search";
    },
  },
  watch: {
    defaultValue: {
      immediate: true,
      handler() {
        if (this.defaultValue.id) {
          this.options = [this.defaultValue];
        }
      },
    },
  },
  methods: {
    mapOrganisationFields(organisation) {
      return {
        ...organisation,
        name: organisation.notArchived()
          ? `#${organisation.id} ${organisation.name}`
          : `${organisation.name} (Inactive)`,
        itemStyle: organisation.notArchived() ? "" : "color: gray",
      };
    },
    async getOrganisationById(query) {
      let organisationFromId = null;

      if (/^\d+$/.test(query.trim())) {
        try {
          organisationFromId = (await Organisation.find(query)).data;
        } catch {
          organisationFromId = null;
        }
      }

      return organisationFromId;
    },
    async filter(query) {
      let results = [];

      if (query) {
        try {
          const order = { name: "asc" };

          let request = Organisation.where({ name: { match: query } });

          if (!this.markInactive) {
            request = request.where({ archived: { eq: false } });
          }

          results = (await request.order(order).per(20).all()).data;
          const organisationFromId = await this.getOrganisationById(query);
          if (organisationFromId) results.unshift(organisationFromId);

          if (this.markInactive) {
            results = results.map((organisation) =>
              this.mapOrganisationFields(organisation)
            );
          } else {
            results = results.map((organisation) => ({
              ...organisation,
              name: `#${organisation.id} ${organisation.name}`,
            }));
          }
        } catch (error) {
          this.$error("Error Loading Organisations", error);
        }
      }

      return results;
    },
  },
};
</script>
